export const styles = {
    mainContainer: {
        px: 0,
        maxW: "100%",
        bg: ["gray.50", "white"],
        position: "relative",
        bottom: 0,
        zIndex: 20,
    },
    container: {
        px: { base: "16px", md: "32px" },
        py: { base: "32px", md: "40px" },
        mx: "auto",
        bg: "white",
        maxW: "container.largeDesktop",
        w: "100%",
    },
    columns: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        rowGap: { base: "24px", md: "32px" },
        columnGap: { base: "20px", md: "24px" },
        pb: { base: "24px", md: "32px" },
        wordBreak: "break-word",
    },
    group: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 0,
        flexShrink: 0,
        gap: { base: "12px", md: "16px", lg: "24px" },
    },
    groupTitle: {
        fontSize: "16px",
        fontWeight: "bold",
        lineHeight: "24px",
        letterSpacing: "0.2px",
        color: "black",
    },
    linkList: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "12px",
        w: "100%",
    },
    link: {
        textDecoration: "none",
        color: "black",
        display: "inline-block",
        maxW: "100%",
        fontSize: { base: "13px", md: "14px" },
        fontWeight: "normal",
        lineHeight: { base: "19px", md: "20px" },
        letterSpacing: "0.6px",
    },
    button: {
        textDecoration: "none",
        color: "black",
        display: "inline-block",
        maxW: "100%",
        textAlign: "left",
        fontSize: { base: "13px", md: "14px" },
        fontWeight: "normal",
        lineHeight: { base: "19px", md: "20px" },
        letterSpacing: "0.6px",
        h: "auto",
        mt: 0,
    },
    divider: {
        borderColor: "gray.100",
        my: 0,
    },
    copyright: {
        py: { base: "20px", md: "24px" },
        fontSize: { base: "11px", md: "12px" },
        lineHeight: { base: "17px", md: "18px" },
        letterSpacing: "0.6px",
        color: "black",
    },
};
